import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/base/SEOMeta';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import CategoriesSection from './components/CategoriesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOMeta
        title="成91官方落地页——成91平台全解析 | 成91官网"
        description="成91是备受关注的热门平台，本页为您全面介绍成91的核心功能、使用指南、用户评价及常见问题解答，助您快速了解成91的真实体验与优势特点，立即探索成91带来的全新体验。"
        keywords="成91,成91平台,成91官网,成91使用指南,成91功能介绍,成91用户评价,成91常见问题"
        canonicalUrl="https://cheng91.com"
        ogType="website"
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <CategoriesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}